import { coreApi } from "./coreApi";

export const financialPeriodsApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinancialPeriods: builder.query({
      query: () => ({
        url: "/accounting/fiscal-periods",
        method: "GET",
      }),
      providesTags: ["FinancialPeriod"],
    }),
  }),
});

export const { useGetFinancialPeriodsQuery } = financialPeriodsApi;

export default financialPeriodsApi;
